import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { enqueueSnackbar } from 'notistack';
import { Button } from '@mui/material';
import Iconify from '../iconify/Iconify';

export default function ExcelDownloadGridButton({ gridRef, fileName, worksheetName, formatMap = {}, excludeFields = [] }) {
  const handleDownload = async () => {
    if (!gridRef?.current?.api) {
      enqueueSnackbar('Failed to download history', { variant: 'error' })
      return;
    }
    const gridApi = gridRef.current.api;
    const columns = gridApi.getColumnDefs?.() || [];
    const filteredColumns = columns.filter(col => !excludeFields.includes(col.field));
    const rowData = [];
    gridApi.forEachNodeAfterFilterAndSort((node) => rowData.push(node.data));
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(`${worksheetName}` || "Sheet1");
    const headers = filteredColumns.map((c) => c.headerName || c.field);
    worksheet.addRow(headers);
    rowData.forEach((row) => {
      const values = filteredColumns.map((col) => {
        const raw = row?.[col.field];
        const format = formatMap[col.field];
        try {
          if (raw == null) return "";
          if (typeof raw === "object") {
            if (Array.isArray(raw)) return raw.join(", ");
            return JSON.stringify(raw);
          }
          if (format?.type === "date") {
            const d = new Date(raw);
            return Number.isNaN(d.getTime()) ? raw : d;
          }
          if (format?.type === "currency") {
            const c = Number(raw);
            return Number.isNaN(c) ? raw : c;
          }
          if (format?.type === "number") {
            const n = Number(raw);
            return Number.isNaN(n) ? raw : n;
          }
          return raw;
        } catch {
          return raw;
        }
      });
      worksheet.addRow(values);
    });

    worksheet.columns.forEach((col, i) => {
      const field = filteredColumns[i]?.field;
      const format = formatMap[field];
      if (format?.type === "date") {
        col.numFmt = "mm/dd/yyyy";
      } else if (format?.type === "currency") {
        col.numFmt = `${format.currencySymbol || "$"}#,##0.00;[Red]-${format.currencySymbol || "$"}#,##0.00`;
      } else if (format?.type === "integer") {
        col.numFmt = "0";
      } else if (format?.type === "number") {
        col.numFmt = "0.00";
      }
    });
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), fileName);
    } catch (err) {
      enqueueSnackbar('Error downloading to Excel file', { variant: 'error' });
    }
  }
  return (
    <Button variant="contained" color="primary" onClick={handleDownload} startIcon={<Iconify icon="mdi:download" />}>
      Download
    </Button>
  );
}
